import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

// Contesto leggero per aprire il pannello dell'assistente da qualunque punto:
// la topbar (con la pagina corrente), la pagina Richieste (senza contesto),
// o il ripristino di una chat ancora aperta dopo un refresh.

export interface ContestoChat {
  urlPagina?: string;
  modulo?: string;
  moduloLabel?: string;
}

interface ChatAssistenzaCtx {
  aperta: boolean;
  contesto: ContestoChat | null;
  chatIdRipristino: number | null;
  apri: (contesto: ContestoChat) => void;
  apriEsistente: (chatId: number) => void;
  chiudi: () => void;
}

const Ctx = createContext<ChatAssistenzaCtx>({
  aperta: false, contesto: null, chatIdRipristino: null,
  apri: () => {}, apriEsistente: () => {}, chiudi: () => {},
});

export function ChatAssistenzaProvider({ children }: { children: React.ReactNode }) {
  const [aperta, setAperta] = useState(false);
  const [contesto, setContesto] = useState<ContestoChat | null>(null);
  const [chatIdRipristino, setChatIdRipristino] = useState<number | null>(null);

  const apri = useCallback((c: ContestoChat) => {
    setContesto(c); setChatIdRipristino(null); setAperta(true);
  }, []);
  const apriEsistente = useCallback((chatId: number) => {
    setContesto(null); setChatIdRipristino(chatId); setAperta(true);
  }, []);
  const chiudi = useCallback(() => {
    setAperta(false); setContesto(null); setChatIdRipristino(null);
  }, []);

  const value = useMemo(
    () => ({ aperta, contesto, chatIdRipristino, apri, apriEsistente, chiudi }),
    [aperta, contesto, chatIdRipristino, apri, apriEsistente, chiudi],
  );
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useChatAssistenza() {
  return useContext(Ctx);
}
